<template>
    <article class="minimal"
             :class="[$options.filters.checkIfArchiveCategory(item, archiveCatId), {'imgHover': type === 'hover'}, {'cat-item__sold-out': isArchive}]">
        <div :class="{'itemHoverInfo': type === 'hover'}">
            <template v-if="type !== 'hover'">
                <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                         :alt="item | itemName"
                                         :title="item | itemName"
                                         :item-url="item | itemURL(urlWithVariationId)"
                                         :enable-carousel="$ceres.config.item.enableImageCarousel"
                                         :disable-carousel-on-mobile="disableCarouselOnMobile"
                                         ref="categoryImageCarousel">
                </category-image-carousel>
            </template>
			<a :href="item | itemURL(urlWithVariationId)">
				<div class="cat-item__title">{{ texts.name2 }}</div>
				<div class="cat-item__desc">{{ texts.name3 }}</div>
				<div v-if="!isArchive" class="cat-item__price">
          <template v-if="item.item.itemType === 'set'">
            {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}
          </template>
          <template v-else-if="itemGraduatedPriceisCheapestSorting">
            {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
          </template>
          <template v-else-if="itemGraduatedPricesalableVariationCount">
            {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
          </template>
          <template v-else>
            {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
          </template>
				</div>
				<div v-else class="cat-item__sold-out-btn">{{ $translate("HoferAntikschmuck::Template.notInStock") }}</div>
			</a>
		</div>
        <template v-if="type === 'hover'">
            <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                     :alt="item | itemName"
                                     :title="item | itemName"
                                     :item-url="item | itemURL(urlWithVariationId)"
                                     :enable-carousel="$ceres.config.item.enableImageCarousel"
                                     :disable-carousel-on-mobile="disableCarouselOnMobile"
                                     ref="categoryImageCarousel">
            </category-image-carousel>
        </template>
    </article>
</template>

<script>
import { mapState } from 'vuex';
import CategoryImageCarousel from "ceres/app/components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "ceres/app/components/itemList/ItemStoreSpecial.vue";
import {getSlotData} from "ceres/app/helper/getSlotData";

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
            {
                type: Number,
                default: 0
            },
        imageUrlAccessor:
            {
                type: String,
                default: "urlMiddle"
            },
        itemData:
            {
                type: Object
            },
        disableCarouselOnMobile:
            {
                type: Boolean
            },
        paddingClasses:
            {
                type: String,
                default: null
            },
        paddingInlineStyles:
            {
                type: String,
                default: null
            },
        forceUrlWithVariationId:
            {
                type: Boolean,
                default: false
            },
        type:
            {
                type: String,
                default: 'hover'
            },
        archiveCatId:
            {
                type: Number
            }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
        {
			isArchive(){
				if(this.item && this.item.defaultCategories){
					for (let key in this.item.defaultCategories){
						if(this.item.defaultCategories[key].id === 80){
							return true
						}
					}
				}
				return false
			},

            item()
            {
                return this.itemData || this.itemSlotData || this.itemDataRef;
            },

            itemSlotData: getSlotData('item-data'),

            /**
             * returns itemData.item.storeSpecial
             */
            storeSpecial()
            {
                return this.item.item.storeSpecial;
            },

            /**
             * returns itemData.texts
             */
            texts()
            {
                return this.item.texts;
            },

            itemPrice()
            {
                return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
            },

            basePrice()
            {
              return this.item.prices.default.basePrice;
            },

            itemPriceGraduated()
            {
              let unitPrice;
              if (App.config.item.enableGraduatedPrices) {
                unitPrice = this.item.prices.graduatedPrices.length > 0
                    ? this.item.prices.graduatedPrices[0].unitPrice
                    : this.item.prices.default.unitPrice;
              } else {
                unitPrice = this.item.prices.default.unitPrice;
              }

                return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
            },

            itemGraduatedPriceisCheapestSorting()
            {
                return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
            },

            itemGraduatedPricesalableVariationCount()
            {
              return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
            },

            itemSetPrice()
            {
                return this.$options.filters.currency(
                    this.item.prices.default.price.value,
                    this.item.prices.default.currency
                );
            },

            urlWithVariationId()
            {
                return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
            },

            hasCrossPrice() {
              const hasRrpPrice = !!this.item.prices.rrp &&
                  this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

              const hasBeforePrice = !!this.item.prices.specialOffer &&
                  !!this.item.prices.default &&
                  this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

              return hasRrpPrice || hasBeforePrice;
            },

            ...mapState({
                showNetPrices: state => state.basket.showNetPrices
            })
        }
}
</script>
